import { render } from "./Frame.component.vue?vue&type=template&id=361238a6&ts=true"
import script from "./Frame.component.vue?vue&type=script&lang=ts"
export * from "./Frame.component.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__